import { HttpClient } from '@/shared/lib/http-client';

export const resendVerificationLetter = async({ email }) => {
  const response = await HttpClient.post('/auth/email/resend', {
    email,
  });

  return response.data;
};
